import React from "react";
import { Location, useLocation } from "react-router";

const LastLocationContext = React.createContext<Location | null>(null);

export const LastLocationProvider = ({ children }) => {
  const location = useLocation();
  const [locations, setLocations] = React.useState<{
    current: Location;
    last: Location | null;
  }>({ current: location, last: null });

  if (locations.current !== location) {
    setLocations({ current: location, last: locations.current });
  }

  return (
    <LastLocationContext.Provider value={locations.last}>
      {children}
    </LastLocationContext.Provider>
  );
};

export const useLastLocation = () => React.useContext(LastLocationContext);
